<div class="filters__field date-picker">
  <mat-form-field [class.date-picker__hidden]="selectedOption() !== customPeriod || showOptions()" appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ 'PD.LABELS.SELECT_DATES' | translate }}</mat-label>
      <mat-date-range-input [rangePicker]="picker" [formGroup]="range">
        <input matStartDate formControlName="start" (dateChange)="onRangeChange()" />
        <input matEndDate formControlName="end" (dateChange)="onRangeChange()" />
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <button matSuffix type="button" class="date-picker__options" aria-label="Options" (click)="openOptions()">
        <svg viewBox="0 0 10 5" width="10" height="5"><path d="M0 0l5 5 5-5z" fill="currentColor" /></svg>
      </button>
  </mat-form-field>
  <mat-form-field [class.date-picker__hidden]="selectedOption() === customPeriod && !showOptions()" appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ 'PD.LABELS.SELECT_DATES' | translate }}</mat-label>
      <mat-select panelClass="custom-date-select-panel" [value]="selectedOption()" (selectionChange)="onOptionSelected($event.value)" (closed)="onSelectClosed()">
        @if (selectedOption() === customPeriod && range.value.start && range.value.end) {
          <mat-select-trigger>{{ range.value.start | date: 'shortDate' }} - {{ range.value.end | date: 'shortDate' }}</mat-select-trigger>
        }
        @for (option of localizedDatesOptions(); track option.value) {
          <mat-option [value]="option.value" (click)="onOptionClicked(option.value)">{{ option.label }}</mat-option>
        }
      </mat-select>
  </mat-form-field>

  <mat-date-range-picker #picker panelClass="custom-date-range-calendar"></mat-date-range-picker>
</div>
